import { componentDidMount } from '../../components/Lifecycles'
import { compose } from 'ramda'
import { connect } from 'react-redux'
import { breadcrumbLoaded } from '../../store/modules/header'

const mapDispatchToProps = dispatch => ({
  breadcrumbLoaded: compose(dispatch, breadcrumbLoaded),
})

const View = () => null

// didMount :: Props -> Action
const didMount = ({ breadcrumbLoaded, crumbs }) => breadcrumbLoaded(crumbs)

// lifecycles :: React.Component -> React.Component
const lifecycles = componentDidMount(didMount)(View)

export default connect(
  null,
  mapDispatchToProps,
)(lifecycles)
